module.exports = "agm-map {\n  height: 100%;\n}\n\n.map {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  height: 65vh;\n  width: 100vw;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/map-editer/map-editer.component.css
// module id = ./src/app/components/map-editer/map-editer.component.css
// module chunks = main